<script>
import transparenciaServico from '../../servico';
import Carregando from '~componentes/Carregando.vue';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { datepicker } from 'vue-strap';
import CabecalhoRelatorio from './CabecalhoRelatorio.vue';

export default {
    name: 'RelatoriosProjeto',
    components: { CabecalhoRelatorio, Carregando, datepicker },
    data() {
        return {
            projeto: null,
            relatorio: null,
            itens: [],
            carregando: true,
            tituloRelatorio: 'Relatório de compras/licitações',
            dataInicio: '',
            dataFim: '',
            RELATORIO_COMPRAS_LICITACOES: '7',
            semResultado: false,
        }
    },
    methods: {
        async carregarProjeto(id) {
            return await transparenciaServico
                .informacaoProjeto(id)
                .then(informacaoProjeto => {
                    this.projeto = informacaoProjeto;
                });
        },
        async gerarRelatorioComprasLicitacoes(id) {
            this.relatorio = null;
            try {
                const response = await transparenciaServico.relatorioComprasLicitacoes(id);
                this.relatorio = response.find(obj =>
                    obj.idPedidoCompra.toString() === this.$route.params.idPedidoCompra.toString()
                );
            } catch (error) {
                throw error;
            }
        },
        async gerarRelatorioItensComprasLicitacoes(idProjeto, idPedidoCompra) {
            const itens = await transparenciaServico.relatorioItensComprasLicitacoes(idProjeto, idPedidoCompra)
            this.itens = itens.length ? itens : [];
        },
        verificaSemResultado() {
            if (this.itens.length === 0 || !this.relatorio || !this.projeto) {
                this.semResultado = true;
            }
        },
        voltar() {
            this.$router.push({
                name: 'transparencia.projetos.detalhar.lancamento',
                query: this.$route.query,
                params: { id: this.$route.params.id, idTipoRelatorio: this.RELATORIO_COMPRAS_LICITACOES }
            });
        },
        imprimirPagina() {
            window.print();
        },
        formatarNumero(valor) {
            return this.$options.filters.formatarNumero(valor);
        },
        exportarExcel() {
            const data = [
                [this.tituloRelatorio],
                [],
                ["Projeto: ", this.projeto.nomeProjeto],
                [],
                ["Data do pedido", "Fornecedor", "Número do pedido"],
                [this.$options.filters.formatarData(this.relatorio.data), this.relatorio.cpfcnpj + " - " + this.relatorio.nomePessoaFisicaJuridica, this.relatorio.numeroPedidoCompra],
                [],
                ["Item", "Descrição", "Quantidade", "Valor unitário", "IPI(%)", "Valor total do item (R$)"],
            ];

            this.itens.forEach(item => {
                data.push([
                    item.item,
                    item.nomeProduto || '---',
                    this.formatarNumero(item.quantidade),
                    this.formatarNumero(item.valorUnitario),
                    this.formatarNumero(item.iPIItemPedido),
                    this.formatarNumero(item.valorTotalItem)
                ]);
            });

            data.push([])
            data.push(["", "", "", "", "Valor total dos itens: ", this.formatarNumero(this.relatorio.valor)]);
            const ws = XLSX.utils.aoa_to_sheet(data);

            const nomeArquivo = "itens_compras_licitacoes";

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, nomeArquivo);

            const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${nomeArquivo}.xlsx`);
        },
        async carregarDados() {
            this.carregando = true;
            this.semResultado = false;
            try {
                await Promise.all([
                    this.carregarProjeto(this.$route.params.id),
                    this.gerarRelatorioComprasLicitacoes(this.$route.params.id),
                    this.gerarRelatorioItensComprasLicitacoes(this.$route.params.id, this.$route.params.idPedidoCompra),
                ]);
                this.verificaSemResultado()
            } catch (error) {
                this.$swal('', 'Ocorreu um erro ao carregar os dados, tente novamente.', 'error');
                this.semResultado = true;
            } finally {
                this.carregando = false;
            }
        },
    },
    watch: {
        '$route': {
            immediate: true,
            async handler(to) {
                if (to.name === 'transparencia.projetos.detalhar-compra-licitacao') {
                    await this.carregarDados();
                }
            }
        }
    },
    async created() {
        await this.carregarDados();
        this.$root.tituloDaPagina = `Portal da transparência`;
    },
}
</script>

<template>
    <div>
        <cabecalho-relatorio :titulo="tituloRelatorio" :nomeProjeto="projeto.nomeProjeto"
            borda=""></cabecalho-relatorio>

        <div class="row hidden-print" style="padding-left:20px">
            <div class="col-md-12 flex-container" style="justify-content:start; padding-left:15px">
                <h2><b>{{ tituloRelatorio }}</b></h2>
            </div>
        </div>

        <div class="row hidden-print" style="padding-left:20px">

            <div class="col-md-10 flex-container" style="justify-content:start; padding-left:15px">
                <h3><b>Projeto: {{ projeto.nomeProjeto }}</b></h3>
            </div>

            <div class="col-md-2 flex-container" style="justify-content:end; gap:10px">

                <button class="btn btn-primary" @click="exportarExcel">
                    <i class="fa fa-file-excel-o"></i> Excel
                </button>

                <button class="btn btn-primary" @click="imprimirPagina">
                    <i class="fa fa-file-pdf-o"></i> PDF
                </button>

                <button class="btn btn-primary" @click="voltar">
                    <i class="fa fa-arrow-left"></i> Voltar
                </button>

            </div>

        </div>

        <Carregando v-if="carregando" style="padding-top:20px"></Carregando>

        <div class="col-xs-12" v-if="semResultado && !carregando" style="padding-top:20px">
            <div class="ibox float-e-margins">
                <div class="ibox-content">
                    <p class="text-center">
                        Nenhum resultado encontrado.
                    </p>
                </div>
            </div>
        </div>

        <div v-if="!carregando && !semResultado" style="padding-top:20px">

            <div class="ibox float-e-margins">
                <div class="ibox-content">
                    <div class="table-responsive">

                        <table class="table relatorio table-bordered table-hover table-striped">
                            <thead>
                                <tr>
                                    <th>Data do pedido</th>
                                    <th>Fornecedor</th>
                                    <th>Número do pedido</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="relatorio">
                                    <td>{{ relatorio.data | formatarData }}</td>
                                    <td>{{ relatorio.cpfcnpj }} - {{ relatorio.nomePessoaFisicaJuridica }}</td>
                                    <td>{{ relatorio.numeroPedidoCompra }}</td>
                                </tr>
                                <tr v-if="!relatorio">
                                    <td colspan="3" class="text-center">Não há dados.</td>
                                </tr>
                            </tbody>
                        </table>

                        <table class="table relatorio table-bordered table-hover table-striped">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Descrição</th>
                                    <th>Quantidade</th>
                                    <th>Valor unitário&nbsp;(R$)</th>
                                    <th>IPI(%)</th>
                                    <th>Valor total do item&nbsp;(R$)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in itens">
                                    <td>{{ item.item || '---' }}</td>
                                    <td>{{ item.nomeProduto || '---' }}</td>
                                    <td>{{ item.quantidade || '---' }}</td>
                                    <td>{{ item.valorUnitario | formatarNumero }}</td>
                                    <td>{{ item.iPIItemPedido | formatarNumero }}</td>
                                    <td :class="'text-right'">{{ item.valorTotalItem | formatarNumero }}</td>
                                </tr>
                                <tr v-if="itens.length !== 0">
                                    <td colspan="5"></td>
                                    <td colspan="1" class="text-right"
                                        style="display: flex; justify-content: space-between; font-weight: bold;">
                                        <span>Total dos itens:</span>
                                        <span>{{ relatorio.valor | formatarNumero }}</span>
                                    </td>
                                </tr>
                                <tr v-if="itens.length === 0">
                                    <td colspan="6" class="text-center">Não há dados.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/DetalharCompraLicitacao.vue